/* globals APP_NAME */
import { Helmet } from "react-helmet"

import FaviconImgAZULIS from "@mkt/azulis/static/images/favicon/favicon.ico"
import FaviconImgCCBR from "@mkt/ccbr/static/images/favicon/favicon.ico"
import FaviconImgIQ from "@mkt/iq/static/images/favicon/favicon.ico"
import FaviconImgCP from "@mkt/cp/static/images/favicon/favicon.ico"
import FaviconImgMASTERCARD from "@mkt/mastercard/static/images/favicon/favicon.ico"

const Metatags = ({
  SEODescription,
  SEOImage,
  SEOKeywords,
  SEORobots,
  SEORouteUrl,
  SEOTitle,
}) => {

  const favicon = {
    azulis: FaviconImgAZULIS,
    ccbr: FaviconImgCCBR,
    iq: FaviconImgIQ,
    cp: FaviconImgCP,
    mastercard: FaviconImgMASTERCARD
  }

  return (
    <Helmet>
      <title>{SEOTitle}</title>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#352ca4" />
      <meta name="description" content={SEODescription} />
      <meta name="application-name" content={SEOTitle} />
      <meta name="description" content={SEODescription} />
      <meta name="keywords" content={SEOKeywords} />
      <meta name="robots" content={SEORobots} />
      <meta property="og:description" content={SEODescription} />
      <meta property="og:image" content={SEOImage} />
      <meta property="og:site_name" content={SEOTitle} />
      <meta property="og:title" content={SEOTitle} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={SEORouteUrl} />

      <link rel="icon" href={favicon[APP_NAME]} />
      <link rel="canonical" href={SEORouteUrl} />

      <link rel="preconnect" href="//apis.google.com" />
      <link rel="preconnect" href="//connect.facebook.net" />
      <link rel="preconnect" href="//firebolt-api.iq.com.br" />
      <link rel="preconnect" href="//fonts.googleapis.com" />
      <link rel="preconnect" href="//fonts.gstatic.com" />
      <link rel="preconnect" href="//www.fullstory.com" />
      <link rel="preconnect" href="//www.googletagmanager.com" />
      <link rel="preconnect" href="//www.google-analytics.com" />

      {APP_NAME === 'cp' && <script type="text/javascript"
        src="https://tags.denakop.com/10881/consumidorpositivo.com.br.js" defer></script>}
    </Helmet>
  )
}

export default Metatags
